export class Definition {
    constructor(public id: number, public title: string, public description: string) {}

    public static fromAny(item: any): Definition {
        if (!item) {
            return new Definition(0, 'None found', 'None found');
        }

        return new Definition(item.id, item.title, item.description);
    }

    public get selector(): string {
        return `id-${this.title.replace(/[\W_]+/g, '_')}`;
    }
}
